import React from 'react';
import ActionButtons, { ActionButtonsProps } from '../common/ActionButtons';
import { useModalInternalContext } from './ModalInternalContext';

const HBModalActions = ({
    align,
    sticky,
    primaryAction,
    secondaryAction
}: ActionButtonsProps) => {
    const { getTestIdProps } = useModalInternalContext();

    const primaryActionWithTestIds = primaryAction && {
        ...primaryAction,
        ...getTestIdProps('secondary')
    };
    const secondaryActionWithTestIds = secondaryAction && {
        ...secondaryAction,
        ...getTestIdProps('primary')
    };

    return (
        <ActionButtons
            align={align}
            sticky={sticky}
            primaryAction={primaryActionWithTestIds}
            secondaryAction={secondaryActionWithTestIds}
        />
    );
};

export default HBModalActions;
